export const AT_SEARCH_SET = 'OPEN_BOARDS_DIALOG_SEARCH_SET';
export const AT_TAB_SET =    'OPEN_BOARDS_DIALOG_TAB_SET';
